export const CONSTANTS = {
    nomDomaine: "https://jessielphotographe.com",
    nomDomaineApi:"https://api.jessielphotographe.com",
    tempsRequisAvantVerificationCredentiel: 3000,
    dossierImage:"https://api.jessielphotographe.com/images/portfolio/",
    regexEmail : /\d-\d\d\d-\d\d\d-\d\d\d\d|\d\d\d-\d\d\d-\d\d\d\d/g,
    cleRecaptcha: "6LcuJl8hAAAAAP3kOiMRXsGz3zLWzdHq55vyeheD"
}